import { FC } from 'react';

interface AlignRightIconProps {
  color?: string;
  size?: string;
  className?: string;
}

export const AlignRightIcon: FC<AlignRightIconProps> = ({
  color = 'currentColor',
  size = '16',
  className,
  ...props
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    {...props}
  >
    <path
      d="M1.59844 2.4L14.3984 2.4M4.98235 5.86667L14.3984 5.86667M1.59844 9.33333L14.3984 9.33333M7.55706 12.8L14.3984 12.8"
      stroke={color}
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
